<template>
  <div class="container-4k">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'App',
}

</script>


<style lang="scss">
@import url('https://fonts.googleapis.com/css2?family=EB+Garamond:wght@700&display=swap');

:root {
  --primary-color: #{$primary-color};
}

.container-4k {
  width: 100vw;
  min-height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  background: inherit;
}

.container-4k > * {
  width: 100%;
  max-width: 3840px;
  min-height: 100vh;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
}

body {
  margin: 0px;
  overflow: hidden;
}

p{
  font-family: 'EB Garamond', serif;
  font-size: 35px;
  font-weight: 400;
  line-height: 1.4;
}

div.container{
  position: relative;
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
}

div.content{
  padding-top: 2.5rem;
  padding-bottom: 2.5rem;
  max-width: 50em;
}

div.footer{
  font-family: Arial, Helvetica, sans-serif;
  position: absolute;
  bottom: 10px;
  width: 100%;
  height: 1rem;
  font-size: xx-small;
  color: $light-text-color;
}

#app {
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: $primary-color;
}
</style>
